
<!-- (detach) - if keyboard "Esc" close -->
<ng-template cdkConnectedOverlay
             (detach)="closeCdkOverlay()"
             (backdropClick)="closeCdkOverlay()"
             [cdkConnectedOverlayHasBackdrop]="true"
             [cdkConnectedOverlayBackdropClass]="'mat-transparent-backdrop'"
             [cdkConnectedOverlayOrigin]="overlayOrigin"
             [cdkConnectedOverlayOpen]="cdkOpen"
             [cdkConnectedOverlayWidth]="cdkOverlayWidth"
             [cdkConnectedOverlayMinHeight]="cdkOverlayMinHeight"
             [cdkConnectedOverlayPositions]="overlayPositions">

  <div class="container" @transformPanel>
    <ng-content></ng-content>
  </div>
</ng-template>
